import {BANKS} from '../../constants/banks';
import {BANK_TYPES} from '../../constants/typesMessages';

export const getSendMessageBankBranch = (bankBranch) => [
  {
    text: bankBranch,
    type: BANK_TYPES.BANK_FLOW
  }
];

export const getMessageQuestionBank = (messages) => {
  messages.push({
    text: 'Em qual banco você gostaria de receber seu saldo de vendas com cartões Alelo?',
    type: 'message-receive'
  });

  return messages;
};

export const getMessageQuestionBankWarning = (messages) => {
  messages.push({
    text: 'Atenção: A conta deve pertencer ao CNPJ do estabelecimento escolhido.',
    type: 'bank-list-msg'
  });

  return messages;
};

export const getMessageQuestionAccount = (messages) => {
  messages.push({
    text: 'E qual o número da sua conta com dígito?',
    type: 'message-receive'
  });

  return messages;
};

export const getMessageQuestionAccountBankCaixa = (messages) => {
  messages.push({
    text: 'Lembre-se que na Caixa Econômica, o número de operação também faz parte da conta! Por favor, digite os números que aparecem no seu cartão como circulado em amarelo na ilustração abaixo:',
    type: 'message-bank-caixa'
  });

  return messages;
};

export const getMessageQuestionAccountBankCaixaInvalid = (messages) => {
  messages.push({
    text: 'Ops, infelizmente não aceitamos contas que não sejam para pessoas jurídicas... O que você deseja fazer agora?',
    type: 'message-bank-account-caixa'
  });

  return messages;
};

const messageBankCaixa = (bankBranch, bankEcObject) => {
  let messages = getSendMessageBankBranch(bankBranch);
  messages = getMessageQuestionAccount(messages);
  messages = getMessageQuestionAccountBankCaixa(messages);

  return {
    messages,
    bank: bankEcObject,
    responseFlowChange: BANK_TYPES.BANK_ACC,
    responseTypeChange: BANK_TYPES.BANK_FLOW,
    completed: false
  };
};

export const messageBankAccount = (bankBranch, bankEcObject) => {
  if (bankEcObject.code === BANKS.CAIXA) {
    return messageBankCaixa(bankBranch, bankEcObject);
  }

  let messages = getSendMessageBankBranch(bankBranch);
  messages = getMessageQuestionAccount(messages);

  return {
    messages,
    bank: bankEcObject,
    responseFlowChange: BANK_TYPES.BANK_ACC,
    responseTypeChange: BANK_TYPES.BANK_FLOW,
    completed: false
  };
};
